import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
//import { UserProfileDetailsComponent } from '../../../profile-view/profile-view.component';
import { SharedPipesModule } from '../../shared-pipes/shared-pipes.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared.module';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { DataTablesModule } from 'angular-datatables';
import { RouterModule, Routes } from '@angular/router';
/*import { JsonpModule, HttpModule } from '@angular/http';*/
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { AuditTrailComponent } from '../../../audit-trail/audit-trail.component';
import { AuditTrailDetailsComponent } from '../../../audit-trail/audit-trail-details/audit-trail-details.component';
import { AuthGuard } from '../../auth/auth.guard.service';
import { UserRole } from '../../enum/enum';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { UserProfileDetailsComponent } from 'src/app/profile-view/profile-view.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { TagInputModule } from 'ngx-chips';
import { AddInterestCriteriaComponent } from '../../../InterestCriteria/add-interest-criteria/add-interest-criteria.component';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { NgxCurrencyDirective } from 'ngx-currency';
/*import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';*/
/*import { NgxMaskDirective} from 'ngx-mask';*/
// import { NgxCurrencyModule } from 'ngx-currency';
import { MatSelectModule } from '@angular/material/select';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldModule,
} from '@angular/material/form-field';
import { MAT_CHECKBOX_DEFAULT_OPTIONS } from '@angular/material/checkbox';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgxMaskDirective, provideNgxMask, NgxMaskPipe } from 'ngx-mask';
import { UsersNotificationsComponent } from '../../../users-notifications/users-notifications.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

const routes: Routes = [
  { path: 'audit-trail', component: AuditTrailComponent },
  { path: 'my-profile', component: UserProfileDetailsComponent },
  { path: 'interest-criteria', component: AddInterestCriteriaComponent },
];
@NgModule({
  declarations: [
    UserProfileDetailsComponent,
    AuditTrailComponent,
    AuditTrailDetailsComponent,
    AddInterestCriteriaComponent,
    UsersNotificationsComponent
  ],
  exports: [
    UserProfileDetailsComponent,
    AuditTrailComponent,
    AuditTrailDetailsComponent,
    RouterModule,
    AddInterestCriteriaComponent,
    UsersNotificationsComponent
  ],
  imports: [
    //JsonpModule,
    //HttpModule,
    // HttpClientModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    //Ng2CompleterModule,
    SharedModule,
    BsDatepickerModule.forRoot(),
    SharedPipesModule,
    TooltipModule,
    DataTablesModule,
    RouterModule.forChild(routes),
    ModalModule.forRoot(),
    CollapseModule.forRoot(),
    BsDropdownModule.forRoot(),
    BsDatepickerModule.forRoot(),
    TabsModule,
    CarouselModule,
    //BrowserAnimationsModule,
    AccordionModule.forRoot(),
    TagInputModule,
    /*// MultiselectDropdownModule,*/
    AngularMultiSelectModule,
    //NgxMaskDirective,
    // NgxMaskModule,
    // NgxCurrencyModule,
 NgxMatSelectSearchModule,
MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    MatAutocompleteModule,
   NgxMaskDirective,
    NgxMaskPipe,
    NgxCurrencyDirective,
    MatSlideToggleModule
  ],
})
export class SharedUserProfileModule {}
